// 同意書確認
import React, { useState, useEffect } from 'react';
import { render } from 'react-dom';
import Heading from '../../molecules/Heading';
import TransitionButton from '../../molecules/TransitionButton';
import { handleBrowserBack } from '../../BrowserBack';
import { isBrowserIe } from '../../BrowserJudgment';
import CenterButton from '../../atoms/CenterButton';
import ShowDocument from '../../molecules/ShowDocument';
import axios from '../../axios';
import LoadingModal from '../../molecules/LoadingModal';
import { isBrowserIOSSafari, isBrowserIpadSafari } from '../../BrowserJudgment';
import { releaseBrowserBack } from '../../BrowserBack';

const ConfirmConsent = () => {
  const [url, setUrl] = useState('');
  // URLパラメータの取得
  const url_params = new URLSearchParams(document.location.search.substring(1));
  const r_id = url_params.get('r_id');
  // ローディング画面表示制御
  const [is_loading, setIsLoading] = useState(false);

  useEffect(() => {
    // ブラウザの戻る・進む禁止
    handleBrowserBack();
    // 表示するPDFの取得
    getDocument();
  }, []);

  const getDocument = async () => {
    setIsLoading(true);
    try {
      const response = await axios.get(
        `${location.origin}${process.env.MIX_MOCK_URL}/api/get_document`,
        {
          params: { r_id: r_id },
        }
      );
      setUrl(response.data);
    } catch (error) {
      console.error(error);
      alert(error.response.data.message);
    }
    setIsLoading(false);
  };

  // 同意書のダウンロード処理
  const handleClick = () => {
    setIsLoading(true);
    try {
      //IOS端末かつsafariの場合、ブラウザバック禁止処理を解除してダウンロードしたファイルを表示後に元画面に戻れるようにする。
      if (isBrowserIOSSafari() || isBrowserIpadSafari()) {
        releaseBrowserBack();
      }

      //ファイルをダウンロードする。
      const url = `${location.origin}${process.env.MIX_MOCK_URL}/api/download_document?r_id=${r_id}`;
      const self_download_link = document.createElement('a');
      document.body.appendChild(self_download_link);
      // note 同意文のファイル名は固定
      self_download_link.download = 'ConsentForm.pdf';
      self_download_link.href = url;
      self_download_link.click();
      self_download_link.remove();
      URL.revokeObjectURL(url);
      URL.revokeObjectURL(url);
    } catch (error) {
      console.error(error);
      alert('システムエラーが発生しました');
    }
    setIsLoading(false);
  };

  // 「戻る」ボタン押下時
  const backTransition = () => {
    if (isBrowserIe()) {
      const node = document.getElementById('confirm-consent');
      location.replace(node?.dataset.referer as string);
    } else {
      location.replace(document.referrer);
    }
  };

  return (
    <>
      <Heading label="同意書確認" size="l" />
      <div className="container-box my-5">
        <ShowDocument url={url} />
        <div className="my-5"></div>
        <CenterButton label="ダウンロード" handleClick={handleClick} />
        <div className="ml-5">
          <TransitionButton label="戻る" handleClick={backTransition} />
        </div>
      </div>
      <LoadingModal show={is_loading} />
    </>
  );
};

if (document.getElementById('confirm-consent')) {
  render(<ConfirmConsent />, document.getElementById('confirm-consent'));
}
